import Vuex from 'vuex';
import { shallowMount, createLocalVue } from '@vue/test-utils';
import XsellProducts from './XsellProducts';

const localVue = createLocalVue();
localVue.use(Vuex);

const createWrapper = (store) => {
  return shallowMount(XsellProducts, {
    store,
    localVue
  });
};

const storeObj = {
  modules: {
    cart: {
      namespaced: true,
      state: {
        addingProduct: false,
        cart: {
          items: [],
          addons: []
        }
      },

      getters: {
        suggestedAddons: () => [],
        productIdInCart: () => () => false
      }
    },

    xsell: {
      namespaced: true,
      state: {
        proProduct: { id: 123 }
      }
    }
  }
};

describe('XsellProducts', () => {
  test('general snapshot', () => {
    let store = new Vuex.Store(storeObj);
    let wrapper = createWrapper(store);
    expect(wrapper.html()).toMatchSnapshot();
  });
});